export default [
  { heading: 'ADMIN' },
  { title: 'Organizations', icon: 'mdi-domain', route: { name: 'OrganizationsList' } },
  // { title: 'Manage Docs', icon: 'mdi-account-box-multiple', route: { name: 'DocsList' } },
  { divider: true }
];
